import { useQuery } from "@tanstack/react-query";

import { api } from "utils/axios";
import useUrlParams from "utils/urlParms";

const GET_TRIBUNAL_REVIEW_QUERY = "get-tribunal-review";

const getTribunalReviews = async (params) => {
  try {
    const response = await api.get(`/tribunalReview`, { params });
    return response.data;
  } catch (e) {
    console.error(e, "Error fetching Visas");
  }
};

const useGetTribunalReviews = () => {
  const { getUrlParams } = useUrlParams();
  const params = getUrlParams();

  return useQuery({
    queryKey: [GET_TRIBUNAL_REVIEW_QUERY, params],

    queryFn: () => getTribunalReviews(params),
  });
};

export { useGetTribunalReviews, GET_TRIBUNAL_REVIEW_QUERY };
